import {schema} from 'normalizr';

import schemaQuestions from "../question/schema";

export default new schema.Entity('pages', {
  questions: [schemaQuestions]
});